import { getGuard } from "components/Guard/Guard";
import {
  MenuItemProps,
  MenuItem,
  SubMenuProps,
  SubMenu
} from "react-pro-sidebar";

export const GuardedMenuItem = getGuard<MenuItemProps>(MenuItem);
export const GuardedSubMenu = getGuard<SubMenuProps>(SubMenu);
